import axios from './axiosService';

/**
 * MLD-3306
 */
export default {
  initForm() {
    return {
      name: null,
      crm_name: null, // MLD-7566
      status: 'Active',
      external_id: null,
      presentations: [],
    }
  },
  async getProduct(productID) {
    return axios.get(`/api/products/${productID}`)
      .then(response => response.data);
  },
  async getProducts(params = {}) {
    const options = {
      params,
    }
    return axios.get(`/api/products`, options)
      .then(response => response.data);
  },
  async update(productID, form) {
    return axios.put(`/api/products/${productID}`, form)
      .then(response => response.data);
  },
  async deleteProduct(productID) { // MLD-4360
    return axios.delete(`/api/products/${productID}`)
      .then(response => response.data);
  }
}
